import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';

import { ErrorService } from './error.service';



@Injectable()
export class AuthService {
  user$: Observable<firebase.User>;
  userBasicInfo$: Observable<{}>;
  userBasicInfoSaved = {};
  originalAttemptedUrl = '';
  studentIdSaved = '';
  hideHeaderAndFooter = false;




  constructor(private router: Router, private afAuth: AngularFireAuth, private afd: AngularFireDatabase, public errorService: ErrorService) {
    this.user$ = this.afAuth.authState;
  }



  // Login
  userLogin(loginInfo) {
    // Return a promise, so we can use .then and .catch
    return new Promise( (resolve, reject) => {
      // Use AngularFire's build in method to login
      this.afAuth.auth.signInWithEmailAndPassword(`${loginInfo.loginId.trim()}@elevenfifty.org`, loginInfo.password).then( authedUserInfo => {
        // Assign userBasicInfo$ to the obervable from Firebase, and subscribe to it
        // When we get an answer back, put that answer into an easily accessible variable
        // Resolve the promise, so we can use a .then from wherever we called it from
        this.userBasicInfo$ = this.afd.object(`/userBasicInfo/${authedUserInfo.user.uid}`).valueChanges();
        this.userBasicInfo$.subscribe(
          value => {
            value = value ? value : {};
            this.userBasicInfoSaved = value;
            this.userBasicInfoSaved['uid'] = authedUserInfo.user.uid;
            resolve();
          },
          err => { console.log('error for userBasicInfo$:'); console.log(err); },
          () => console.log('completed userBasicInfo$ subscribe inside ngAfterViewInit, inside header.component.ts')
        );
      }).catch( err => {
        // Log the error and send a rejection back for the promise's answer
        console.log('Error inside emailLogin, in auth.service.ts:');
        console.log(err);
        // this.errorService.showErrorMessage('Error while trying to log in');
        reject(err);
      });
    });
  }



  // Logs the user out and routes them to the homepage
  logout() {
    this.userBasicInfoSaved = {};
    this.afAuth.auth.signOut();
    this.router.navigateByUrl('/');
  }



  // Checks the current user's role against the required provided role
  checkRole(roleRequired) {
    return new Promise( (resolve, reject) => {
      // If there is already a user, the AuthState will change... it goes from NotAuthed -> Yes Authed
      this.afAuth.auth.onAuthStateChanged(user => {
        // When that AuthState changes, check if there is a user
        if (user) {
          this.afd.database.ref(`userBasicInfo/${user.uid}`).once('value').then( thisUserInfo => {
            // Get the role out of the user info, and see if it matches the required role. Return this result to where this promise was called
            resolve(thisUserInfo.val()['role'] === roleRequired);
          }).catch( err => {
            // Log the error and send a rejection back for the promise's answer
            console.log('Error inside checkRole, in auth.service.ts:');
            console.log(err);
            this.errorService.showErrorMessage('Unable to find current user in database');
            reject('Unable to find user in database');
          });
        } else {
          console.log('checkRole() said there is NO USER - so we get logged out and sent to the home page');
          reject('No current user');
        }
      });
    });
  }





}
